import { getEnvVar } from '../utils/env'
import { EnvironmentVariable } from './env'

export const MFA_METHOD = {
  NONE: 0,
  AUTHENTICATOR_APP: 1,
  SMS: 2,
}

export const MFA_ENFORCED = {
  ENABLED: 'Enabled',
  OPTIONAL: 'Optional',
}

export const MODULE_TYPES = {
  INTERNAL: 'client_internal',
  EXTERNAL: 'client_external',
  GENERIC: 'generic',
}

// Regular Expressions for Validations
export const REGEX_PATTERNS = {
  COLOR_REGEX: '^#(?:[0-9a-fA-F]{3}){1,2}$',
  EMAIL_REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
}
export const LOCAL_STORAGE_KEYS = {
  USER: 'USER',
}

export const ERROR_MESSAGES = {
  SOMETHING_WENT_WRONG: 'Something went wrong, please try again later',
}

export const SNACKBAR_SEVERITY = {
  SUCCESS: 'success',
  ATTENTION: 'error',
  URGENT: 'urgent',
  INFO: 'info',
}

export const uploadS3FileApiURL = (slug: any, assetName: string, assetType: string) => {
  const BASE_API_URL = `${getEnvVar(EnvironmentVariable.CCS_API_URL)}/api`
  return `${BASE_API_URL}/white-label-configuration/signed_url/${slug}/${assetType}/${assetName}/`
}

// Regex for routes which does not require any permission when logged in
export const NO_PERMISSION_REQUIRED_ROUTES = ['/', '/users/my-profile', '/mfa(/.*)?']
